const data = [
  {
    id: 1,
    image: "https://harshportfolioreact.netlify.app/swiggy/swiggy1.png",
    alt: "Zoomcar",
    name: " Swiggy  clone",
    description: "Responsive Swiggy website clone",
    stack: "ReactJS,Redux,Tailwind ,CSS,JSON SERVER,axios",
    link: "https://swiggy-masai.netlify.app/home", 
    github: "https://github.com/Harsh09889/SwiggyClone"
  },
  {
    id: 2,
    image: "/images/zoomcar.png",
    alt: "Zoomcar",
    name: "Zoomcar Clone",
    description: "Car Rental Services",
    stack: "HTML, CSS, Javascript",
    link: "https://stately-sorbet-a949a7.netlify.app/index.html", 
    github: "https://github.com/abhiraj68/Zoomcar"
  },
  {
    id: 3,
    image: "/images/appletv.png",
    alt: "Apple Tv Clone",
    name: "Apple Tv Clone",
    description: "OTT Platform",
    stack: "HTML, CSS, Javascript,Bootstrap",
    link: "https://appletvindia.netlify.app/", 
    github: "https://github.com/abhiraj68/Apple-Tv-Clone"
  },
  {
    id: 4,
    image: "/images/bliss.png",
    alt: "Tailwindplates",
    name: "Blissworld Clone ",
    description: "Ecom",
    stack: "HTML,CSS, React,Redux,Chakra UI",
    link: "https://bliss-world-clone.vercel.app/", 
    github: "https://github.com/anuragn0507/BlissWorld-clone"
  },

]

export default data;
